export default function () {
  return this.sendEvent('contacts.settings.permissions', {})
}
